import styled, { css, keyframes } from 'styled-components';

declare module '@nucleus/web-theme-elements' {
  interface WebThemeElementsTheme {
    Skeleton?: {
      colorLight?: string;
      colorDark?: string;
    };
  }
}

const shimmer = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

const skeletonBase = css`
  background-image: linear-gradient(
    90deg,
    ${({ theme }) => theme._webThemeElements.Skeleton?.colorDark ?? '#d8d8d8'} 25%,
    ${({ theme }) => theme._webThemeElements.Skeleton?.colorLight ?? '#eeeeee'} 50%,
    ${({ theme }) => theme._webThemeElements.Skeleton?.colorDark ?? '#d8d8d8'} 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.8s linear infinite;
  border-radius: 4px;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    background-size: 100% 100%;
  }
`;

export const SkeletonBlock = styled.div`
  ${skeletonBase}
`;

export const SkeletonText = styled.div<{ width?: string }>`
  ${skeletonBase}
  height: 14px;
  width: ${({ width }) => width ?? '100%'};
`;
